<template>
	<div class="user_navleft">
		<div class="user_navlist">
			<h5 class="clearfloat"><i><img class="img-default" src="../../../assets/images/ttshop_nav1.png" alt=""></i><span>订单中心</span></h5>
			<ul>
				<li :class="{active:index=='ttshop_usermyorder'}" @click="goTtshop_usermyorder"><span>我的订单</span></li>
				<!-- <li><span>评价/晒单</span></li> -->
			</ul>
		</div>
		<div class="user_navlist" v-if="false">
			<h5 class="clearfloat"><i><img class="img-default" src="../../../assets/images/ttshop_nav2.png" alt=""></i><span>我的资产</span></h5>
			<ul>
				<li :class="{active:index=='ttshop_mybalance'}" @click="goTtshop_mybalance"><span>我的余额</span></li>
				<li :class="{active:index=='ttshop_coupon'}" @click="mycoupon"><span>我的优惠券</span></li>
				<li :class="{active:index=='integral_detail'}" @click="toIntegralDetail()"><span>我的积分</span></li>
			</ul>
		</div>
		<div class="user_navlist" v-if="false">
			<h5 class="clearfloat"><i><img class="img-default" src="../../../assets/images/ttshop_nav3.png" alt=""></i><span>我的收藏</span></h5>
			<ul>
				<li  :class="{active:index=='ttshop_mycollection'}" @click="collshop"><span>收藏的商品</span></li>
				<!-- <li><span>收藏的专题</span></li> -->
				<li  :class="{active:index=='ttshop_store'}" @click="collstore" ><span>关注的店铺</span></li>
				<!-- <li><span>收藏的短视频</span></li> -->
			</ul>
		</div>
		<!-- <div class="user_navlist">
			<h5 class="clearfloat"><i><img class="img-default" src="../../../assets/images/ttshop_nav4.png" alt=""></i><span>我的活动</span></h5>
			<ul>
				<li><span>我的拼团</span></li>
				<li><span>我的预约</span></li>
			</ul>
		</div> -->
		<div class="user_navlist">
			<h5 class="clearfloat"><i><img class="img-default" src="../../../assets/images/ttshop_nav5.png" alt=""></i><span>客户服务</span></h5>
			<ul>
				<!-- <li><span>返修退换货</span></li> -->
				<li :class="{active:index=='ttshop_invoice'}" @click="goTtshop_invoice"><span>我的发票</span></li>
				<li :class="{active:index=='ttshop_invoiceInformation'}" @click="goTtshop_invoiceInformation"><span>发票信息</span></li>
				<!-- <li :class="{active:index=='ttshop_invoiceIfdetails'}" @click="goTtshop_invoiceIfdetails"><span>发票信息详情</span></li> -->
				<!-- <li :class="{active:index=='ttshop_addinvoice'}" @click="goTtshop_addinvoice"><span>新增发票抬头</span></li> -->
			</ul>
		</div>
		<!-- <div class="user_navlist">
			<h5 class="clearfloat"><i><img class="img-default" src="../../../assets/images/ttshop_nav6.png" alt=""></i><span>分销管理</span></h5>
			<ul>
				<li><span>我的分销</span></li>
			</ul>
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				index: ''
			};
		},
		methods: {
			goTtshop_mybalance() {
				this.$router.push("/ttshop_mybalance");
			},
			toIntegralDetail() {
				this.$router.push("/integral_detail");
			},
			goTtshop_usermyorder() {
				this.$router.push("/ttshop_usermyorder");
			},
			goTtshop_invoice() {
				this.$router.push("/ttshop_invoice");
			},
			goTtshop_invoiceInformation(){
				this.$router.push("/ttshop_invoiceInformation");
			},
			goTtshop_invoiceIfdetails(){
				this.$router.push("/ttshop_invoiceIfdetails");
			},
			goTtshop_addinvoice(){
				this.$router.push("/ttshop_addinvoice");
			},
			mycoupon(){
				this.$router.push("/ttshop_coupon")
			},
			//收藏的商品
			collshop(){
				this.$router.push("/ttshop_mycollection")
			},
			//收藏的店铺
			collstore(){
				this.$router.push("/ttshop_store")
			},
		},
		created() {
			this.index = this.$route.name
		},
	};
</script>

<style lang="scss" scoped>
	.user_navleft {
		float: left;
		width: 190px;
		// min-height: 810px;
		margin-right: 10px;
		background: #fff;

		.user_navlist {
			width: 100%;
			padding: 12px 0;
			box-sizing: border-box;
			border-bottom: 1px solid #ebebeb;

			h5 {
				width: 100%;
				padding: 0 12px 13px 12px;
				box-sizing: border-box;

				i {
					float: left;
					width: 16px;
					height: 16px;
					margin-top: 3px;
					margin-right: 4px;

					img {
						display: block;
						width: 100%;
					}
				}

				span {
					float: left;
					font-size: 16px;
					color: #333;
					font-weight: 500;
				}
			}

			ul {
				li {
					display: block;
					width: 100%;
					padding: 8px 32px;
					box-sizing: border-box;

					span {
						// font-size: 12px;
						font-size: 14px;
						color: #999;
						cursor: pointer;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:hover {
							color: #ff0e25;
						}
					}

					&.active span {
						color: #ff0e25;
					}
				}
			}

			&:last-child {
				border-bottom: 0;
			}
		}
	}
</style>
